
import { Options, Vue } from "vue-class-component";
import { store } from "@/store";
import {
  dispatchGetMyProjects,
  dispatchGetProjectDetail,
  dispatchGetProjects,
  dispatchGetProjectUsersPage,
} from "@/store/project/actions";
import {
  readAdminProjects,
  readMyProjects,
  readProjectDetail,
} from "@/store/project/getters";
import { dispatchUpdateMyLastProject } from "@/store/main/actions";
import {
  getLocalProject,
  saveLocalProject,
  saveLocalStorageProject,
  unique_json,
} from "@/utils";
import { readUserProfile } from "@/store/main/getters";
@Options({
  components: {},
})
export default class SideMenu extends Vue {
  public pagesList = [];
  public async mounted() {
    if (this.$route.query.project && "screenshot" in this.$route.query) {
      const project = Number(this.$route.query.project);
      // 记录一下最后访问的项目
      await dispatchUpdateMyLastProject(store, { last_visit_project: project });
      await saveLocalProject(String(project));
      await saveLocalStorageProject(String(project));
    }

    await dispatchGetProjectUsersPage(store, {
      project: this.localProject,
    }).then((res) => {
      this.pagesList = res;
    });

    await dispatchGetProjectDetail(store, {
      id: this.localProject,
      project: this.localProject,
    });

    this.searchVal = readProjectDetail(store);
    await dispatchGetMyProjects(store);
    await dispatchGetProjects(store, { project: this.localProject });
    if (this.get_is_super) {
      let list = [
        "/task",
        "/task-record",
        "/svn_log",
        "/ds_log",
        "/svn_log",
        "/In-office-script",
        "/image-recognition-script",
        "/account-management",
        "/authority-management",
        "/pipeline-management",
        "/device-management",
        "/scene-management",
        "/report_setting",
        "/project_setting",
        "/notification-settings",
      ];
      if (list.includes(this.$route.path)) {
        this.$router.push("/403");
      }
    }
    // await this.asideMenu;
    window.addEventListener("scroll", this.fixedActiveBtn);
    // console.log(this.getMyLastProjectName.indexOf('AOV')!==-1);
  }
  public search = "";
  public isCollapse = false;
  public localProject = Number(getLocalProject());
  // public asideMenu: any[] = [];
  // openeds(path: any) {
  //   if (path in ["/taskDetails", "task"]) {
  //     return ["/Workbench"];
  //   } else {
  //     return ["/Workbench", "/admin", "/dashboard"];
  //   }
  // }
  public handleMenuItemClick(path, event) {
    console.log(path);
    if (event.ctrlKey || event.metaKey) {
      const url = this.$router.resolve({ path }).href;
      window.open(url, "_blank");
    }
  }
  public searchVal = {};
  public openeds = [
    "/live_test_report",
    "/deep_performance_test_Report",
    "/adb",
    "/smoke_record",
    "/inclusion_resources",
  ];
  public get asideMenu() {
    let asideMenuVal = [
      // {
      //   title: "Dashboard",
      //   index: "/workbench",
      //   sub: [{ title: "Dashboard", path: "/workbench", icon: "el-icon-s-data" }],
      // },
      {
        title: "客户端性能",
        index: "/performance",
        adminRequire: false,
        sub: [
          {
            title: "perf数据",
            path: "/perf_data",
            icon: "el-icon-menu",
            style:
              Number(getLocalProject()) === 12
                ? "display:block"
                : "display:none",
          },

          {
            title: "性能概况",
            path: "/deep_performance_cpu_summary",
            icon: "el-icon-menu",
            style: "display:block",
          },
          {
            title: "测试数据汇总",
            path: "/project_overview",
            icon: "el-icon-menu",
            style: "",
          },
          // {
          //   title: "客户端性能专项",
          //   path: "/performance_chart",
          //   icon: "el-icon-s-data",
          // },
          // {
          //   title: "报告列表",
          //   path: "/report_list",
          //   icon: "el-icon-document",
          //   style: "",
          // },
          {
            title: "测试报告汇总",
            path:
              Number(getLocalProject()) === 18 ||
              Number(getLocalProject()) === 14 ||
              Number(getLocalProject()) === 23 ||
              Number(getLocalProject()) === 24
                ? "/test_report_aov2"
                : "/test_report" && Number(getLocalProject()) === 22
                ? "/test_report_top"
                : "/test_report" &&
                  (Number(getLocalProject()) === 7 ||
                    Number(getLocalProject()) === 26)
                ? "/test_report_speedmobile"
                : "/test_report" && Number(getLocalProject()) === 12
                ? "/nzm_test_report"
                : "/test_report",
            // && Number(getLocalProject()) === 27
            // ? "/wedo"
            // : "/test_report",
            icon: "el-icon-document",
            // style: Number(getLocalProject()) === 27
            //     ? "display:none"
            //     : "display:block",
          },
          {
            title: "跑图性能测试",
            path: "/cfr_test_report",
            // && Number(getLocalProject()) === 27
            // ? "/wedo"
            // : "/test_report",
            icon: "el-icon-document",
            style:
              Number(getLocalProject()) === 37 ||
              Number(getLocalProject()) === 53
                ? "display:block"
                : "display:none",
          },
          {
            title: "武器性能测试",
            path: "/cfm_arms_report",
            // && Number(getLocalProject()) === 27
            // ? "/wedo"
            // : "/test_report",
            icon: "el-icon-document",
            style:
              Number(getLocalProject()) === 42 ||
              Number(getLocalProject()) === 37 ||
              Number(getLocalProject()) === 53
                ? "display:block"
                : "display:none",
          },
          {
            title: "PVE性能测试",
            path: "/cfm_pve_report",
            // && Number(getLocalProject()) === 27
            // ? "/wedo"
            // : "/test_report",
            icon: "el-icon-document",
            style:
              Number(getLocalProject()) === 42 ||
              Number(getLocalProject()) === 37 ||
              Number(getLocalProject()) === 53
                ? "display:block"
                : "display:none",
          },
          {
            title: "dawnskilltest ",
            path: "/label_scenario_report",
            icon: "el-icon-tickets",
            style:
              Number(getLocalProject()) === 37 ||
              Number(getLocalProject()) === 53
                ? "display:block"
                : "display:none",
          },

          {
            title: "用例监控 ",
            path: "/use_case_monitoring",
            icon: "el-icon-tickets",
            style:
              Number(getLocalProject()) === 37 ||
              Number(getLocalProject()) === 53
                ? "display:block"
                : "display:none",
          },
          {
            title: "DC统计",
            path: "/dc_statistics",
            // && Number(getLocalProject()) === 27
            // ? "/wedo"
            // : "/test_report",
            icon: "el-icon-document",
            style:
              Number(getLocalProject()) === 45
                ? "display:block"
                : "display:none",
          },
          // {
          //   title: "性能分析",
          //   path: "/performance_analysis",
          //   icon: "el-icon-data-analysis",
          //   style: "",
          // },
          {
            title: "5v5十真人测试",
            path: "/live_test_report",
            icon: "el-icon-data-analysis",
            style:
              Number(getLocalProject()) === 32 ||
              Number(getLocalProject()) === 18 ||
              Number(getLocalProject()) === 34 ||
              Number(getLocalProject()) === 47 ||
              Number(getLocalProject()) === 40
                ? "display:block"
                : "display:none",
            children: [
              {
                title: "5V5十真人测试报告",
                path: "/live_test_report",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 32 ||
                  Number(getLocalProject()) === 18 ||
                  Number(getLocalProject()) === 34 ||
                  Number(getLocalProject()) === 47 ||
                  Number(getLocalProject()) === 40,
              },
              {
                title: "5V5十真人邮件报告",
                path: "/live_test_report_new",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 32 ||
                  Number(getLocalProject()) === 18 ||
                  Number(getLocalProject()) === 34 ||
                  Number(getLocalProject()) === 47 ||
                  Number(getLocalProject()) === 40,
              },
            ],
          },
          {
            title: "深度性能测试",
            path: "/deep_performance_test_Report",
            icon: "el-icon-data-analysis",
            style:
              Number(getLocalProject()) === 7 ||
              Number(getLocalProject()) === 12 ||
              Number(getLocalProject()) === 4 ||
              Number(getLocalProject()) === 48 ||
              Number(getLocalProject()) === 34 ||
              Number(getLocalProject()) === 37 ||
              Number(getLocalProject()) === 53 ||
              Number(getLocalProject()) === 49
                ? "display:block"
                : "display:none",
            children: [
              // {
              //   title: "CPU性能数据上传",
              //   path: "/deep_performance_cpu_data_upload",
              //   icon: "el-icon-data-analysis",
              //   show:
              //     Number(getLocalProject()) === 7 ||
              //     Number(getLocalProject()) === 12 ||
              //           Number(getLocalProject()) === 48 ||
              //     Number(getLocalProject()) === 34,
              // },
              // {
              //   title: "CPU性能数据分析",
              //   path: "/automated_cpu_functions",
              //   icon: "el-icon-data-analysis",
              //   show:
              //     Number(getLocalProject()) === 7 ||
              //     Number(getLocalProject()) === 48 ||
              //     Number(getLocalProject()) === 12 ||
              //     Number(getLocalProject()) === 34,
              // },
              // {
              //   title: "CPU性能数据查看",
              //   path: "/deep_performance_cpu_data",
              //   icon: "el-icon-data-analysis",
              //   show:
              //     Number(getLocalProject()) === 7 ||
              //     Number(getLocalProject()) === 12 ||
              //     Number(getLocalProject()) === 34,
              // },

              // {
              //   title: "CPU性能数据测试报告",
              //   path: "/deep_performance_cpu_test_report",
              //   icon: "el-icon-data-analysis",
              //   show:
              //     Number(getLocalProject()) === 7 ||
              //     Number(getLocalProject()) === 48 ||
              //     Number(getLocalProject()) === 12 ||
              //     Number(getLocalProject()) === 34,
              // },
              {
                title: "对象内存",
                path: "/object_memory",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 34,
              },
              {
                title: "Unity资源内存-详细数据",
                path: "/memory_resource_monitoring",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 7,
              },
              {
                title: "Unity资源内存-历史数据",
                path: "/history_memory_resource_monitoring",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 7,
              },

              {
                title:
                  Number(getLocalProject()) === 7
                    ? "Android深度内存"
                    : "perfetto内存测试报告",
                path: "/perfetto_memory",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 34 ||
                  Number(getLocalProject()) === 37 ||
                  Number(getLocalProject()) === 4 ||
                  Number(getLocalProject()) === 7 ||
                  Number(getLocalProject()) === 53,
              },
              {
                title:
                  Number(getLocalProject()) === 7
                    ? "iOS深度内存"
                    : "xcode内存测试报告",
                path: "/xcode_memory",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 34 ||
                  Number(getLocalProject()) === 37 ||
                  Number(getLocalProject()) === 4 ||
                  Number(getLocalProject()) === 7 ||
                  Number(getLocalProject()) === 53,
              },
              {
                title: "深度性能分析",
                path: "/deep_performance_analysis",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 34 ||
                  Number(getLocalProject()) === 37 ||
                  Number(getLocalProject()) === 48 ||
                  Number(getLocalProject()) === 4 ||
                  Number(getLocalProject()) === 7 ||
                  Number(getLocalProject()) === 12 ||
                  Number(getLocalProject()) === 53 ||
                  Number(getLocalProject()) === 49,
              },

              // {
              //   title: "内存性能",
              //   path: "/deep_memory_performance",
              //   icon: "el-icon-data-analysis",
              //   show: Number(getLocalProject()) === 12,
              // },
              {
                title: "内存数据查看",
                path: "/memory_data",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 12 ||
                  Number(getLocalProject()) === 48 ||
                  Number(getLocalProject()) === 34,
              },
              // {
              //   title: "内存测试报告",
              //   path: "/memory_report_new",
              //   icon: "el-icon-data-analysis",
              //   show: Number(getLocalProject()) === 34,
              // },
              {
                title: "内存测试报告",
                path: "/memory_report",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 34,
              },
              {
                title: "SimplePerf测试报告",
                path: "/simple_perf_live",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 34,
              },
              // {
              //   title: "SimplePerf测试报告",
              //   path: "/simple_perf2",
              //   icon: "el-icon-data-analysis",
              //   show: Number(getLocalProject()) === 7,
              // },
              {
                title: "SimplePerf数据查看",
                path: "/simple_perf_data",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 34,
              },
              {
                title: "GPU Counter",
                path: "/gpu_counter",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 7
                    ? this.use_name_super2
                      ? true
                      : false
                    : false,
              },
              {
                title: "GPU Counter",
                path: "/gpu_counter2",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 12,
              },
              // {
              //   title: "包体资源",
              //   path: "/inclusion_resources",
              //   icon: "el-icon-data-analysis",
              //   show: Number(getLocalProject()) === 12,
              // },
              // {
              //   title: "包体资源测试报告",
              //   path: "/inclusion_resources_test_report",
              //   icon: "el-icon-data-analysis",
              //   show: Number(getLocalProject()) === 12,
              // },
              //               {
              //   title: "光照异常测试报告",
              //   path: "/abnormal_lighting_test_report",
              //   icon: "el-icon-data-analysis",
              //   show: Number(getLocalProject()) === 12,
              // },
            ],
          },
          {
            title: "美术资源扫描",
            path: "/resource_scanning",
            icon: "el-icon-data-analysis",
            style:
              Number(getLocalProject()) === 7
                ? "display:block"
                : "display:none",
            children: [
              // {
              //   title: "全局概览",
              //   path: "/resource_scanning",
              //   icon: "el-icon-data-analysis",
              //   show:
              //     Number(getLocalProject()) === 34 ||
              //     Number(getLocalProject()) === 37 ||
              //     Number(getLocalProject()) === 4 ||
              //     Number(getLocalProject()) === 7 ||
              //     Number(getLocalProject()) === 53,
              // },
              {
                title: "全局概览",
                path: "/resource_scan_overview",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 7
              },
              {
                title: "一级页面",
                path: "/resource_scan_primary_car",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 7,
                children: [
                  {
                    title: "基础资源",
                    path: "/resource_scan_primary_base",
                    icon: "el-icon-data-analysis",
                    show: Number(getLocalProject()) === 7
                  },
                  {
                    title: "赛车",
                    path: "/resource_scan_primary_car",
                    icon: "el-icon-data-analysis",
                    show: Number(getLocalProject()) === 7
                  },
                  {
                    title: "角色",
                    path: "/resource_scan_primary_role",
                    icon: "el-icon-data-analysis",
                    show: Number(getLocalProject()) === 7
                  },
                  {
                    title: "骑宠",
                    path: "/resource_scan_primary_pet_ride",
                    icon: "el-icon-data-analysis",
                    show: Number(getLocalProject()) === 7
                  },
                  {
                    title: "宠物",
                    path: "/resource_scan_primary_pet",
                    icon: "el-icon-data-analysis",
                    show: Number(getLocalProject()) === 7
                  },
                  {
                    title: "座椅",
                    path: "/resource_scan_primary_throne",
                    icon: "el-icon-data-analysis",
                    show: Number(getLocalProject()) === 7
                  },
                ],
              },
              {
                title: "二级页面",
                path: "/resource_scan_sub_car",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 7,
                children: [
                  {
                    title: "基础资源",
                    path: "/resource_scan_sub_base",
                    icon: "el-icon-data-analysis",
                    show: Number(getLocalProject()) === 7
                  },
                  {
                    title: "赛车",
                    path: "/resource_scan_sub_car",
                    icon: "el-icon-data-analysis",
                    show: Number(getLocalProject()) === 7
                  },
                  {
                    title: "角色",
                    path: "/resource_scan_sub_role",
                    icon: "el-icon-data-analysis",
                    show: Number(getLocalProject()) === 7
                  },
                  {
                    title: "骑宠",
                    path: "/resource_scan_sub_pet_ride",
                    icon: "el-icon-data-analysis",
                    show: Number(getLocalProject()) === 7
                  },
                  {
                    title: "宠物",
                    path: "/resource_scan_sub_pet",
                    icon: "el-icon-data-analysis",
                    show: Number(getLocalProject()) === 7
                  },
                  {
                    title: "座椅",
                    path: "/resource_scan_sub_throne",
                    icon: "el-icon-data-analysis",
                    show: Number(getLocalProject()) === 7
                  },
                ],
              },
            ],
          },
          {
            title: "深度性能New",
            // title: "深度性能分析",
            path: "/deep_performance_analysis",
            icon: "el-icon-data-analysis",
            style:
              // Number(getLocalProject()) === 7 ||
              Number(getLocalProject()) === 12 ||
              Number(getLocalProject()) === 4 ||
              Number(getLocalProject()) === 48 ||
              Number(getLocalProject()) === 34 ||
              Number(getLocalProject()) === 37 ||
              Number(getLocalProject()) === 53
                ? "display:block"
                : "display:none",
            children: [
              {
                title: "性能概况",
                // title: "深度性能分析",
                path: "/deep_performance_new_overview",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 7 ||
                  Number(getLocalProject()) === 4 ||
                  Number(getLocalProject()) === 48 ||
                  Number(getLocalProject()) === 12 ||
                  Number(getLocalProject()) === 34,
              },
              {
                title: "CPU性能",
                // title: "深度性能分析",
                path: "/deep_performance_cpu_performance",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 7 ||
                  Number(getLocalProject()) === 4 ||
                  Number(getLocalProject()) === 48 ||
                  Number(getLocalProject()) === 12 ||
                  Number(getLocalProject()) === 34,
              },
              {
                title: "GPU性能",
                // title: "深度性能分析",
                path: "/deep_performance_gpu_performance",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 7 ||
                  Number(getLocalProject()) === 4 ||
                  Number(getLocalProject()) === 48 ||
                  Number(getLocalProject()) === 12 ||
                  Number(getLocalProject()) === 34,
              },
              {
                title: "线程性能",
                // title: "深度性能分析",
                path: "/deep_performance_thread_performance",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 7 ||
                  Number(getLocalProject()) === 4 ||
                  Number(getLocalProject()) === 48 ||
                  Number(getLocalProject()) === 12 ||
                  Number(getLocalProject()) === 34,
              },
              {
                title: "全量函数耗时",
                // title: "深度性能分析",
                path: "/deep_performance_total_functions",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 7 ||
                  Number(getLocalProject()) === 4 ||
                  Number(getLocalProject()) === 48 ||
                  Number(getLocalProject()) === 12 ||
                  Number(getLocalProject()) === 34,
              },
              {
                title: "卡顿分析",
                // title: "深度性能分析",
                path: "/deep_performance_lag_analysis",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 7 ||
                  Number(getLocalProject()) === 4 ||
                  Number(getLocalProject()) === 48 ||
                  Number(getLocalProject()) === 12 ||
                  Number(getLocalProject()) === 34,
              },
              // {
              //   title: "卡顿分析",
              //   // title: "深度性能分析",
              //   path: "/deep_performance_analysis",
              //   icon: "el-icon-data-analysis",
              //   show:
              //     Number(getLocalProject()) === 7 ||
              //     Number(getLocalProject()) === 4 ||
              //     Number(getLocalProject()) === 48 ||
              //     Number(getLocalProject()) === 12 ||
              //     Number(getLocalProject()) === 34,
              // },
              {
                title: "自定义模块",
                // title: "深度性能分析",
                path: "/deepPeformance_configuration",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 7 ||
                  Number(getLocalProject()) === 4 ||
                  Number(getLocalProject()) === 48 ||
                  Number(getLocalProject()) === 12 ||
                  Number(getLocalProject()) === 34,
              },
            ],
          },
          {
            title: "Top性能",
            path: "/TopData",
            icon: "el-icon-data-analysis",
            style:
              Number(getLocalProject()) === 17 ||
              Number(getLocalProject()) === 12 ||
              Number(getLocalProject()) === 22
                ? "display:block"
                : "display:none",
            children: [
              {
                title: "Top数据",
                path: "/TopData",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 17 ||
                  Number(getLocalProject()) === 12 ||
                  Number(getLocalProject()) === 22,
              },
              {
                title: "数据查找",
                path: "/top_search",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 17 ||
                  Number(getLocalProject()) === 12 ||
                  Number(getLocalProject()) === 22,
              },
            ],
          },
          {
            title: "包体测试",
            path: "/inclusion_resources",
            icon: "el-icon-data-analysis",
            style:
              Number(getLocalProject()) === 12
                ? "display:block"
                : "display:none",
            children: [
              {
                title: "包体资源",
                path: "/inclusion_resources",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 12,
              },
              {
                title: "包体资源测试报告",
                path: "/inclusion_resources_test_report",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 12,
              },
            ],
          },
          {
            title: "性能日志分析",
            path: "/adb",
            icon: "el-icon-data-analysis",
            style:
              Number(getLocalProject()) === 34
                ? "display:block"
                : "display:none",
            children: [
              {
                title: "ADB日志",
                path: "/adb",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 34,
              },
              {
                title: "LightPerf",
                path: "/light_perf",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 34,
              },
              {
                title: "安卓APP文件",
                path: "/android_app_file",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 34,
              },
              {
                title: "安卓线进程性能监测",
                path: "/android_line_process_performance_detection",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 34,
              },
            ],
          },
          {
            title: "功能冒烟",
            path: "/smoke_record",
            icon: "el-icon-data-analysis",
            style:
              Number(getLocalProject()) === 4 ||
              Number(getLocalProject()) === 17 ||
              Number(getLocalProject()) === 12 ||
              Number(getLocalProject()) === 32 ||
              Number(getLocalProject()) === 37 ||
              Number(getLocalProject()) === 53 ||
              Number(getLocalProject()) === 34 ||
              Number(getLocalProject()) === 47 ||
              Number(getLocalProject()) === 40 ||
              Number(getLocalProject()) === 48 ||
              Number(getLocalProject()) === 39 ||
              Number(getLocalProject()) === 61 ||
              Number(getLocalProject()) === 62 ||
              Number(getLocalProject()) === 49
                ? "display:block"
                : "display:none",
            children: [
              {
                title: "冒烟记录",
                path: "/smoke_record",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 4 ||
                  Number(getLocalProject()) === 17 ||
                  Number(getLocalProject()) === 12 ||
                  Number(getLocalProject()) === 37 ||
                  Number(getLocalProject()) === 53 ||
                  Number(getLocalProject()) === 34 ||
                  Number(getLocalProject()) === 47 ||
                  Number(getLocalProject()) === 48 ||
                  Number(getLocalProject()) === 40 ||
                  Number(getLocalProject()) === 39 ||
                  Number(getLocalProject()) === 61 ||
                  Number(getLocalProject()) === 49,
              },
              {
                title: "功能冒烟报告",
                path: "/automated_smoke_test",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 4 ||
                  Number(getLocalProject()) === 17 ||
                  Number(getLocalProject()) === 32 ||
                  Number(getLocalProject()) === 12 ||
                  Number(getLocalProject()) === 37 ||
                  Number(getLocalProject()) === 53 ||
                  Number(getLocalProject()) === 34 ||
                  Number(getLocalProject()) === 48 ||
                  Number(getLocalProject()) === 47 ||
                  Number(getLocalProject()) === 40 ||
                  Number(getLocalProject()) === 39 ||
                  Number(getLocalProject()) === 49,
              },
              {
                title: "登录遍历测试报告",
                path: "/login_traversal_report",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 48,
              },
              {
                title: "协议测试报告",
                path: "/protocol_test_report",
                icon: "el-icon-data-analysis",
                show: [61, 62].includes(Number(getLocalProject())),
              },
              {
                title: "道具自动化测试报告",
                path: "/auto_test_report",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 61,
              },
            ],
          },
          {
            title: "光照冒烟",
            path: "/smoke_from_light_exposure",
            icon: "el-icon-data-analysis",
            style:
              Number(getLocalProject()) === 12
                ? "display:block"
                : "display:none",
            children: [
              {
                title: "场景光照",
                path: "/smoke_from_light_exposure",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 12,
              },
              {
                title: "角色光照",
                path: "/smoke_from_light_exposure_role",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 12,
              },
              {
                title: "Lookdev",
                path: "/smoke-from-light-exposure-lookdev",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 12,
              },
            ],
          },
          {
            title: "皮肤异常检测",
            path: "/skin_managemente",
            icon: "el-icon-data-analysis",
            style:
              Number(getLocalProject()) === 34 ||
              Number(getLocalProject()) === 47 ||
              Number(getLocalProject()) === 40 ||
              Number(getLocalProject()) === 32
                ? "display:block"
                : "display:none",
          },
          // {
          //   title: "冒烟记录",
          //   path: "/smoke_record",
          //   icon: "el-icon-data-analysis",
          //   style:
          //     Number(getLocalProject()) === 4 ||
          //     Number(getLocalProject()) === 17 ||
          //     Number(getLocalProject()) === 12 ||
          //     Number(getLocalProject()) === 37 ||
          //     Number(getLocalProject()) === 34 ||
          //     Number(getLocalProject()) === 47 ||
          //     Number(getLocalProject()) === 40 ||
          //     Number(getLocalProject()) === 39 ||
          //     Number(getLocalProject()) === 49
          //       ? "display:block"
          //       : "display:none",
          // },
          {
            title: "其他测试",
            path: "/ai_test_report",
            icon: "el-icon-data-analysis",
            style:
              Number(getLocalProject()) === 34 ||
              Number(getLocalProject()) === 32 ||
              Number(getLocalProject()) === 47 ||
              Number(getLocalProject()) === 57 ||
              Number(getLocalProject()) === 40
                ? "display:block"
                : "display:none",
            children: [
              {
                title: "皮肤性能数据",
                path: "/hok_domestic",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 57,
              },
              {
                title: "局外皮肤维护",
                path: "/skin_maintenance",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 34,
              },
              {
                title: "生成表格数据",
                path: "/generate_table_data",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 34 ||
                  Number(getLocalProject()) === 47 ||
                  Number(getLocalProject()) === 40,
              },
              {
                title: "AI测试",
                path: "/ai_test_report",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 34 ||
                  Number(getLocalProject()) === 47 ||
                  Number(getLocalProject()) === 40,
              },
              {
                title: "局外皮肤测试报告",
                path: "/test_report_skin",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 34 ||
                  Number(getLocalProject()) === 32 ||
                  Number(getLocalProject()) === 47 ||
                  Number(getLocalProject()) === 57 ||
                  Number(getLocalProject()) === 40,
              },
              {
                title: "局外皮肤数据查看",
                path: "/test_report_skin_data",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 34 ||
                  Number(getLocalProject()) === 47 ||
                  Number(getLocalProject()) === 40,
              },
              {
                title: "局内皮肤性能",
                path: "/test_report_skin_inside",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 34 ||
                  Number(getLocalProject()) === 32 ||
                  Number(getLocalProject()) === 47 ||
                  Number(getLocalProject()) === 57 ||
                  Number(getLocalProject()) === 40,
              },
              {
                title: "极限性能测试",
                path: "/ultimate_performance_test",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 34 ||
                  Number(getLocalProject()) === 32 ||
                  Number(getLocalProject()) === 47 ||
                  Number(getLocalProject()) === 57 ||
                  Number(getLocalProject()) === 40,
              },
              {
                title: "预实例化资源统计",
                path: "/resource_statistics",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 34 ||
                  Number(getLocalProject()) === 47 ||
                  Number(getLocalProject()) === 40,
              },
            ],
          },
          {
            title: "皮肤测试报告",
            path: "/test_report_skin_osgame",
            icon: "el-icon-data-analysis",
            style:
              Number(getLocalProject()) === 36
                ? "display:block"
                : "display:none",
          },
          {
            title: "关卡测试",
            path: "/",
            icon: "el-icon-data-analysis",
            style:
              Number(getLocalProject()) === 59
                ? "display:block"
                : "display:none",
            children: [
              {
                title: "关卡测试报告",
                path: "/test_report_skin_smg",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 59,
              },
            ],
          },

          {
            title: "UI性能测试",
            path: "/ui_test_report",
            icon: "el-icon-data-analysis",
            style:
              Number(getLocalProject()) === 36
                ? "display:block"
                : "display:none",
          },
          {
            title: "UI测试",
            path: "/ui_test_smg_report",
            icon: "el-icon-data-analysis",
            style:
              Number(getLocalProject()) === 59
                ? "display:block"
                : "display:none",
            children: [
              {
                title: "UI测试报告",
                path: "/ui_test_smg_report",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 59,
              },
            ],
          },
          {
            title: "UI&关卡测试",
            path: "/ui_and_level_test_report",
            icon: "el-icon-data-analysis",
            style:
              Number(getLocalProject()) === 59
                ? "display:block"
                : "display:none",
            children: [
              {
                title: "UI&关卡测试报告",
                path: "/ui_and_level_test_report",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 59,
              },
            ],
          },
          {
            title: "MonoDump",
            path: "/mono_dump",
            icon: "el-icon-c-scale-to-original",
            style:
              Number(getLocalProject()) === 13 ||
              Number(getLocalProject()) === 15 ||
              Number(getLocalProject()) === 16 ||
              Number(getLocalProject()) === 44
                ? "display:block"
                : "display:none",
          },
          {
            title: "xHook",
            path: "/x_hook",
            icon: "el-icon-tickets",
            style:
              Number(getLocalProject()) === 13 ||
              Number(getLocalProject()) === 15 ||
              Number(getLocalProject()) === 16
                ? "display:block"
                : "display:none",
          },
          {
            title: "标签场景报告",
            path: "/label_scenario_report",
            icon: "el-icon-tickets",
            style:
              Number(getLocalProject()) === 8 ||
              Number(getLocalProject()) === 59 ||
              Number(getLocalProject()) === 54 ||
              Number(getLocalProject()) === 49
                ? "display:block"
                : "display:none",
          },

          {
            title: "标签场景热力图",
            path: "/label_scenario_diagram",
            icon: "el-icon-tickets",
            style:
              Number(getLocalProject()) === 8 ||
              Number(getLocalProject()) === 20
                ? "display:block"
                : "display:none",
          },
          // {
          //   title: "wedo",
          //   path: "/wedo",
          //   icon: "el-icon-tickets",
          //   style:
          //     Number(getLocalProject()) === 27
          //       ? "display:block"
          //       : "display:none",
          // },
          {
            title: "自定义报告",
            path: "/custom_report",
            icon: "el-icon-tickets",
            // style: ''
            style:
              Number(getLocalProject()) === 18 ||
              Number(getLocalProject()) === 14 ||
              Number(getLocalProject()) === 23 ||
              Number(getLocalProject()) === 24
                ? "display:block"
                : "display:none",
          },
          // {
          //   title: "测试",
          //   path: "/reactars",
          //   icon: "el-icon-menu",
          // },
        ],
      },
      {
        title: "自动化任务",
        index: "/automated-tasks",
        sub: [
          {
            title: "测试任务",
            path: "/task",
            icon: "el-icon-set-up",
            style: "",
          },
          {
            title: "执行历史",
            path: "/task-record",
            icon: "el-icon-tickets",
            style: "",
          },
          {
            title: "其他",
            path: "/svn_log",
            icon: "el-icon-data-analysis",
            style:
              Number(getLocalProject()) === 4
                ? "display:block"
                : "display:none",
            children: [
              {
                title: "DS日志",
                path: "/ds_log",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 4,
              },
              {
                title: "svn日志",
                path: "/svn_log",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 4,
              },
            ],
          },
        ],
      },
      {
        title: "自动化脚本",
        index: "/scripts",
        adminRequire: false,
        sub: [
          {
            title: "场景脚本",
            path: "/In-office-script",
            icon: "el-icon-video-camera",
            style: "",
          },
          {
            title: "图像识别脚本",
            path: "/image-recognition-script",
            icon: "el-icon-picture-outline",
            style: "",
          },
        ],
      },
      {
        title: "设置",
        index: "/setting",
        sub: [
          {
            title: "账号管理",
            path: "/account-management",
            icon: "el-icon-user",
            style: "",
          },
          {
            title: "权限管理",
            path: "/authority-management",
            icon: "el-icon-lock",
            style: "",
          },
          {
            title: "流水线管理",
            path: "/pipeline-management",
            icon: "el-icon-download",
            style: "",
          },
          {
            title: "设备管理",
            path: "/device-management",
            icon: "el-icon-mobile-phone",
            style: "",
          },
          {
            title: "项目场景",
            path: "/scene-management",
            icon: "el-icon-place",
            style: "",
          },
          {
            title: "报告设置",
            path: "/report_setting",
            icon: "el-icon-tickets",
            style: "",
          },
          {
            title: "项目设置",
            path: "/project_setting",
            icon: "el-icon-set-up",
            style: "",
          },
          {
            title: "通知设置",
            path: "/notification-settings",
            icon: "el-icon-bell",
            style: "",
          },
        ],
      },
    ];
    let asideMenuVal2 = [
      {
        title: "客户端性能",
        index: "/performance",
        adminRequire: false,
        sub: [
          {
            title: "perf数据",
            path: "/perf_data",
            icon: "el-icon-menu",
            style:
              Number(getLocalProject()) === 12
                ? "display:block"
                : "display:none",
          },
          {
            title: "性能概况",
            path: "/deep_performance_cpu_summary",
            icon: "el-icon-menu",
            style: "display:block",
          },
          {
            title: "测试数据汇总",
            path: "/project_overview",
            icon: "el-icon-menu",
            style: "",
          },
          // {
          //   title: "客户端性能专项",
          //   path: "/performance_chart",
          //   icon: "el-icon-s-data",
          // },
          // {
          //   title: "报告列表",
          //   path: "/report_list",
          //   icon: "el-icon-document",
          //   style: "",
          // },
          {
            title: "测试报告汇总",
            path:
              Number(getLocalProject()) === 18 ||
              Number(getLocalProject()) === 14 ||
              Number(getLocalProject()) === 23 ||
              Number(getLocalProject()) === 24
                ? "/test_report_aov2"
                : "/test_report" && Number(getLocalProject()) === 22
                ? "/test_report_top"
                : "/test_report" &&
                  (Number(getLocalProject()) === 7 ||
                    Number(getLocalProject()) === 26)
                ? "/test_report_speedmobile"
                : "/test_report" && Number(getLocalProject()) === 12
                ? "/nzm_test_report"
                : "/test_report",
            // && Number(getLocalProject()) === 27
            // ? "/wedo"
            // : "/test_report",
            icon: "el-icon-document",
            // style: Number(getLocalProject()) === 27
            //     ? "display:none"
            //     : "display:block",
          },
          {
            title: "跑图性能测试",
            path: "/cfm_arms_report",
            // && Number(getLocalProject()) === 27
            // ? "/wedo"
            // : "/test_report",
            icon: "el-icon-document",
            style:
              Number(getLocalProject()) === 37 ||
              Number(getLocalProject()) === 53
                ? "display:block"
                : "display:none",
          },
          {
            title: "武器性能测试",
            path: "/cfm_arms_report",
            // && Number(getLocalProject()) === 27
            // ? "/wedo"
            // : "/test_report",
            icon: "el-icon-document",
            style:
              Number(getLocalProject()) === 42 ||
              Number(getLocalProject()) === 37 ||
              Number(getLocalProject()) === 53
                ? "display:block"
                : "display:none",
          },
          {
            title: "dawnskilltest",
            path: "/label_scenario_report",
            icon: "el-icon-tickets",
            style:
              Number(getLocalProject()) === 37 ||
              Number(getLocalProject()) === 53
                ? "display:block"
                : "display:none",
          },
          {
            title: "用例监控 ",
            path: "/use_case_monitoring",
            icon: "el-icon-tickets",
            style:
              Number(getLocalProject()) === 37 ||
              Number(getLocalProject()) === 53
                ? "display:block"
                : "display:none",
          },
          {
            title: "DC统计",
            path: "/dc_statistics",
            // && Number(getLocalProject()) === 27
            // ? "/wedo"
            // : "/test_report",
            icon: "el-icon-document",
            style:
              Number(getLocalProject()) === 45
                ? "display:block"
                : "display:none",
          },
          // {
          //   title: "性能分析",
          //   path: "/performance_analysis",
          //   icon: "el-icon-data-analysis",
          //   style: "",
          // },
          {
            title: "5v5十真人测试",
            path: "/live_test_report",
            icon: "el-icon-data-analysis",
            style:
              Number(getLocalProject()) === 32 ||
              Number(getLocalProject()) === 18 ||
              Number(getLocalProject()) === 34 ||
              Number(getLocalProject()) === 47 ||
              Number(getLocalProject()) === 40
                ? "display:block"
                : "display:none",
            children: [
              {
                title: "5V5十真人测试报告",
                path: "/live_test_report",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 32 ||
                  Number(getLocalProject()) === 18 ||
                  Number(getLocalProject()) === 34 ||
                  Number(getLocalProject()) === 47 ||
                  Number(getLocalProject()) === 40,
              },
              {
                title: "5V5十真人邮件报告",
                path: "/live_test_report_new",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 32 ||
                  Number(getLocalProject()) === 18 ||
                  Number(getLocalProject()) === 34 ||
                  Number(getLocalProject()) === 47 ||
                  Number(getLocalProject()) === 40,
              },
            ],
          },
          {
            title: "深度性能测试",
            path: "/deep_performance_test_Report",
            icon: "el-icon-data-analysis",
            style:
              Number(getLocalProject()) === 7 ||
              Number(getLocalProject()) === 12 ||
              Number(getLocalProject()) === 4 ||
              Number(getLocalProject()) === 48 ||
              Number(getLocalProject()) === 34 ||
              Number(getLocalProject()) === 37 ||
              Number(getLocalProject()) === 53
                ? "display:block"
                : "display:none",
            children: [
              {
                title: "对象内存",
                path: "/object_memory",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 34,
              },
              // {
              //   title: "CPU性能数据上传",
              //   path: "/deep_performance_cpu_data_upload",
              //   icon: "el-icon-data-analysis",
              //   show:
              //     Number(getLocalProject()) === 7 ||
              //     Number(getLocalProject()) === 12 ||
              //           Number(getLocalProject()) === 48 ||

              // },
              // {
              //   title: "CPU性能数据分析",
              //   path: "/automated_cpu_functions",
              //   icon: "el-icon-data-analysis",
              //   show:
              //     Number(getLocalProject()) === 7 ||
              //     Number(getLocalProject()) === 48 ||
              //     Number(getLocalProject()) === 12 ||
              //     Number(getLocalProject()) === 34,
              // },
              // {
              //   title: "CPU性能数据查看",
              //   path: "/deep_performance_cpu_data",
              //   icon: "el-icon-data-analysis",
              //   show:
              //     Number(getLocalProject()) === 7 ||
              //     Number(getLocalProject()) === 12 ||
              //     Number(getLocalProject()) === 34,
              // },

              // {
              //   title: "CPU性能数据测试报告",
              //   path: "/deep_performance_cpu_test_report",
              //   icon: "el-icon-data-analysis",
              //   show:
              //     Number(getLocalProject()) === 7 ||
              //     Number(getLocalProject()) === 48 ||
              //     Number(getLocalProject()) === 12 ||
              //     Number(getLocalProject()) === 34,
              // },
              {
                title: "Unity资源内存-详细数据",
                path: "/memory_resource_monitoring",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 7,
              },
              {
                title: "Unity资源内存-历史数据",
                path: "/history_memory_resource_monitoring",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 7,
              },
              {
                title: "Unity资源扫描",
                path: "/resource_scanning",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 7,
              },
              {
                title:
                  Number(getLocalProject()) === 7
                    ? "Android深度内存"
                    : "perfetto内存测试报告",
                path: "/perfetto_memory",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 34 ||
                  Number(getLocalProject()) === 37 ||
                  Number(getLocalProject()) === 4 ||
                  Number(getLocalProject()) === 7 ||
                  Number(getLocalProject()) === 53,
              },
              {
                title:
                  Number(getLocalProject()) === 7
                    ? "iOS深度内存"
                    : "xcode内存测试报告",

                path: "/xcode_memory",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 34 ||
                  Number(getLocalProject()) === 37 ||
                  Number(getLocalProject()) === 4 ||
                  Number(getLocalProject()) === 7 ||
                  Number(getLocalProject()) === 53,
              },
              {
                title: "深度性能分析",
                path: "/deep_performance_analysis",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 34 ||
                  Number(getLocalProject()) === 37 ||
                  Number(getLocalProject()) === 48 ||
                  Number(getLocalProject()) === 12 ||
                  Number(getLocalProject()) === 4 ||
                  Number(getLocalProject()) === 7 ||
                  Number(getLocalProject()) === 53,
              },

              // {
              //   title: "内存性能",
              //   path: "/deep_memory_performance",
              //   icon: "el-icon-data-analysis",
              //   show: Number(getLocalProject()) === 12,
              // },
              {
                title: "内存数据查看",
                path: "/memory_data",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 12 ||
                  Number(getLocalProject()) === 48 ||
                  Number(getLocalProject()) === 34,
              },
              // {
              //   title: "内存测试报告",
              //   path: "/memory_report_new",
              //   icon: "el-icon-data-analysis",
              //   show: Number(getLocalProject()) === 34,
              // },
              {
                title: "内存测试报告",
                path: "/memory_report",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 34,
              },
              {
                title: "SimplePerf测试报告",
                path: "/simple_perf_live",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 34,
              },
              // {
              //   title: "SimplePerf测试报告",
              //   path: "/simple_perf2",
              //   icon: "el-icon-data-analysis",
              //   show: Number(getLocalProject()) === 7,
              // },
              {
                title: "SimplePerf数据查看",
                path: "/simple_perf_data",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 34,
              },
              {
                title: "GPU Counter",
                path: "/gpu_counter",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 7
                    ? this.use_name_super2
                      ? true
                      : false
                    : false,
              },
              {
                title: "GPU Counter",
                path: "/gpu_counter2",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 12,
              },
              // {
              //   title: "包体资源",
              //   path: "/inclusion_resources",
              //   icon: "el-icon-data-analysis",
              //   show: Number(getLocalProject()) === 12,
              // },
              // {
              //   title: "包体资源测试报告",
              //   path: "/inclusion_resources_test_report",
              //   icon: "el-icon-data-analysis",
              //   show: Number(getLocalProject()) === 12,
              // },
              // {
              //   title: "光照异常测试报告",
              //   path: "/abnormal_lighting_test_report",
              //   icon: "el-icon-data-analysis",
              //   show: Number(getLocalProject()) === 12,
              // },
            ],
          },
          {
            title: "深度性能New",
            // title: "深度性能分析",
            path: "/deep_performance_analysis",
            icon: "el-icon-data-analysis",
            style:
              // Number(getLocalProject()) === 7 ||
              Number(getLocalProject()) === 12 ||
              Number(getLocalProject()) === 4 ||
              Number(getLocalProject()) === 48 ||
              Number(getLocalProject()) === 34 ||
              Number(getLocalProject()) === 37 ||
              Number(getLocalProject()) === 53
                ? "display:block"
                : "display:none",
            children: [
              {
                title: "性能概况",
                // title: "深度性能分析",
                path: "/deep_performance_new_overview",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 7 ||
                  Number(getLocalProject()) === 4 ||
                  Number(getLocalProject()) === 48 ||
                  Number(getLocalProject()) === 12 ||
                  Number(getLocalProject()) === 34,
              },
              {
                title: "CPU性能",
                // title: "深度性能分析",
                path: "/deep_performance_cpu_performance",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 7 ||
                  Number(getLocalProject()) === 4 ||
                  Number(getLocalProject()) === 48 ||
                  Number(getLocalProject()) === 12 ||
                  Number(getLocalProject()) === 34,
              },
              {
                title: "GPU性能",
                // title: "深度性能分析",
                path: "/deep_performance_gpu_performance",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 7 ||
                  Number(getLocalProject()) === 4 ||
                  Number(getLocalProject()) === 48 ||
                  Number(getLocalProject()) === 12 ||
                  Number(getLocalProject()) === 34,
              },
              {
                title: "线程性能",
                // title: "深度性能分析",
                path: "/deep_performance_thread_performance",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 7 ||
                  Number(getLocalProject()) === 4 ||
                  Number(getLocalProject()) === 48 ||
                  Number(getLocalProject()) === 12 ||
                  Number(getLocalProject()) === 34,
              },
              {
                title: "全量函数耗时",
                // title: "深度性能分析",
                path: "/deep_performance_total_functions",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 7 ||
                  Number(getLocalProject()) === 4 ||
                  Number(getLocalProject()) === 48 ||
                  Number(getLocalProject()) === 12 ||
                  Number(getLocalProject()) === 34,
              },
              {
                title: "卡顿分析",
                // title: "深度性能分析",
                path: "/deep_performance_lag_analysis",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 7 ||
                  Number(getLocalProject()) === 4 ||
                  Number(getLocalProject()) === 48 ||
                  Number(getLocalProject()) === 12 ||
                  Number(getLocalProject()) === 34,
              },
              // {
              //   title: "卡顿分析",
              //   // title: "深度性能分析",
              //   path: "/deep_performance_analysis",
              //   icon: "el-icon-data-analysis",
              //   show:
              //     Number(getLocalProject()) === 7 ||
              //     Number(getLocalProject()) === 4 ||
              //     Number(getLocalProject()) === 48 ||
              //     Number(getLocalProject()) === 12 ||
              //     Number(getLocalProject()) === 34,
              // },
              {
                title: "自定义模块",
                // title: "深度性能分析",
                path: "/deepPeformance_configuration",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 7 ||
                  Number(getLocalProject()) === 4 ||
                  Number(getLocalProject()) === 48 ||
                  Number(getLocalProject()) === 12 ||
                  Number(getLocalProject()) === 34,
              },
            ],
          },
          {
            title: "Top性能",
            path: "/TopData",
            icon: "el-icon-data-analysis",
            style:
              Number(getLocalProject()) === 17 ||
              Number(getLocalProject()) === 12 ||
              Number(getLocalProject()) === 22
                ? "display:block"
                : "display:none",
            children: [
              {
                title: "Top数据",
                path: "/TopData",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 17 ||
                  Number(getLocalProject()) === 12 ||
                  Number(getLocalProject()) === 22,
              },
              {
                title: "数据查找",
                path: "/top_search",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 17 ||
                  Number(getLocalProject()) === 12 ||
                  Number(getLocalProject()) === 22,
              },
            ],
          },
          {
            title: "包体测试",
            path: "/inclusion_resources",
            icon: "el-icon-data-analysis",
            style:
              Number(getLocalProject()) === 12
                ? "display:block"
                : "display:none",
            children: [
              {
                title: "包体资源",
                path: "/inclusion_resources",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 12,
              },
              {
                title: "包体资源测试报告",
                path: "/inclusion_resources_test_report",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 12,
              },
            ],
          },
          {
            title: "性能日志分析",
            path: "/adb",
            icon: "el-icon-data-analysis",
            style:
              Number(getLocalProject()) === 34
                ? "display:block"
                : "display:none",
            children: [
              {
                title: "ADB日志",
                path: "/adb",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 34,
              },
              {
                title: "LightPerf",
                path: "/light_perf",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 34,
              },
              {
                title: "安卓APP文件",
                path: "/android_app_file",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 34,
              },
              {
                title: "安卓线进程性能监测",
                path: "/android_line_process_performance_detection",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 34,
              },
            ],
          },
          {
            title: "功能冒烟",
            path: "/smoke_record",
            icon: "el-icon-data-analysis",
            style:
              Number(getLocalProject()) === 4 ||
              Number(getLocalProject()) === 48 ||
              Number(getLocalProject()) === 17 ||
              Number(getLocalProject()) === 32 ||
              Number(getLocalProject()) === 12 ||
              Number(getLocalProject()) === 37 ||
              Number(getLocalProject()) === 53 ||
              Number(getLocalProject()) === 34 ||
              Number(getLocalProject()) === 47 ||
              Number(getLocalProject()) === 61 ||
              Number(getLocalProject()) === 62 ||
              Number(getLocalProject()) === 40 ||
              Number(getLocalProject()) === 39 ||
              Number(getLocalProject()) === 49
                ? "display:block"
                : "display:none",
            children: [
              {
                title: "冒烟记录",
                path: "/smoke_record",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 4 ||
                  Number(getLocalProject()) === 17 ||
                  Number(getLocalProject()) === 48 ||
                  Number(getLocalProject()) === 12 ||
                  Number(getLocalProject()) === 37 ||
                  Number(getLocalProject()) === 53 ||
                  Number(getLocalProject()) === 34 ||
                  Number(getLocalProject()) === 47 ||
                  Number(getLocalProject()) === 40 ||
                  Number(getLocalProject()) === 39 ||
                  Number(getLocalProject()) === 61 ||
                  Number(getLocalProject()) === 49,
              },
              {
                title: "功能冒烟报告",
                path: "/automated_smoke_test",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 4 ||
                  Number(getLocalProject()) === 17 ||
                  Number(getLocalProject()) === 32 ||
                  Number(getLocalProject()) === 12 ||
                  Number(getLocalProject()) === 37 ||
                  Number(getLocalProject()) === 48 ||
                  Number(getLocalProject()) === 53 ||
                  Number(getLocalProject()) === 34 ||
                  Number(getLocalProject()) === 47 ||
                  Number(getLocalProject()) === 40 ||
                  Number(getLocalProject()) === 39 ||
                  Number(getLocalProject()) === 49,
              },
              {
                title: "登录遍历测试报告",
                path: "/login_traversal_report",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 48,
              },
              {
                title: "协议测试报告",
                path: "/protocol_test_report",
                icon: "el-icon-data-analysis",
                show: [61, 62].includes(Number(getLocalProject())),
              },
            ],
          },
          {
            title: "光照冒烟",
            path: "/smoke_from_light_exposure",
            icon: "el-icon-data-analysis",
            style:
              Number(getLocalProject()) === 12
                ? "display:block"
                : "display:none",
            children: [
              {
                title: "场景光照",
                path: "/smoke_from_light_exposure",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 12,
              },
              {
                title: "角色光照",
                path: "/smoke_from_light_exposure_role",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 12,
              },
              {
                title: "Lookdev",
                path: "/smoke-from-light-exposure-lookdev",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 12,
              },
            ],
          },
          {
            title: "皮肤异常检测",
            path: "/skin_managemente",
            icon: "el-icon-data-analysis",
            style:
              Number(getLocalProject()) === 34 ||
              Number(getLocalProject()) === 47 ||
              Number(getLocalProject()) === 40 ||
              Number(getLocalProject()) === 32
                ? "display:block"
                : "display:none",
          },
          // {
          //   title: "冒烟记录",
          //   path: "/smoke_record",
          //   icon: "el-icon-data-analysis",
          //   style:
          //     Number(getLocalProject()) === 4 ||
          //     Number(getLocalProject()) === 17 ||
          //     Number(getLocalProject()) === 12 ||
          //     Number(getLocalProject()) === 37 ||
          //     Number(getLocalProject()) === 34 ||
          //     Number(getLocalProject()) === 47 ||
          //     Number(getLocalProject()) === 40 ||
          //     Number(getLocalProject()) === 39 ||
          //     Number(getLocalProject()) === 49
          //       ? "display:block"
          //       : "display:none",
          // },

          {
            title: "其他测试",
            path: "/ai_test_report",
            icon: "el-icon-data-analysis",
            style:
              Number(getLocalProject()) === 34 ||
              Number(getLocalProject()) === 32 ||
              Number(getLocalProject()) === 47 ||
              Number(getLocalProject()) === 57 ||
              Number(getLocalProject()) === 40
                ? "display:block"
                : "display:none",
            children: [
              {
                title: "皮肤性能数据",
                path: "/hok_domestic",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 57,
              },
              {
                title: "局外皮肤维护",
                path: "/skin_maintenance",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 34,
              },
              {
                title: "生成表格数据",
                path: "/generate_table_data",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 34 ||
                  Number(getLocalProject()) === 47 ||
                  Number(getLocalProject()) === 40,
              },
              {
                title: "AI测试",
                path: "/ai_test_report",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 34 ||
                  Number(getLocalProject()) === 47 ||
                  Number(getLocalProject()) === 40,
              },
              {
                title: "局外皮肤测试报告",
                path: "/test_report_skin",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 34 ||
                  Number(getLocalProject()) === 32 ||
                  Number(getLocalProject()) === 47 ||
                  Number(getLocalProject()) === 57 ||
                  Number(getLocalProject()) === 40,
              },
              {
                title: "局外皮肤数据查看",
                path: "/test_report_skin_data",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 34 ||
                  Number(getLocalProject()) === 47 ||
                  Number(getLocalProject()) === 40,
              },
              {
                title: "局内皮肤性能",
                path: "/test_report_skin_inside",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 34 ||
                  Number(getLocalProject()) === 32 ||
                  Number(getLocalProject()) === 47 ||
                  Number(getLocalProject()) === 57 ||
                  Number(getLocalProject()) === 40,
              },
              {
                title: "极限性能测试",
                path: "/ultimate_performance_test",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 34 ||
                  Number(getLocalProject()) === 32 ||
                  Number(getLocalProject()) === 47 ||
                  Number(getLocalProject()) === 57 ||
                  Number(getLocalProject()) === 40,
              },
              {
                title: "预实例化资源统计",
                path: "/resource_statistics",
                icon: "el-icon-data-analysis",
                show:
                  Number(getLocalProject()) === 34 ||
                  Number(getLocalProject()) === 47 ||
                  Number(getLocalProject()) === 40,
              },
            ],
          },
          {
            title: "皮肤测试报告",
            path: "/test_report_skin_osgame",
            icon: "el-icon-data-analysis",
            style:
              Number(getLocalProject()) === 36
                ? "display:block"
                : "display:none",
          },
          {
            title: "关卡测试",
            path: "/test_report_skin_smg",
            icon: "el-icon-data-analysis",
            style:
              Number(getLocalProject()) === 59
                ? "display:block"
                : "display:none",
            children: [
              {
                title: "关卡测试报告",
                path: "/test_report_skin_smg",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 59,
              },
            ],
          },
          {
            title: "UI性能测试",
            path: "/ui_test_report",
            icon: "el-icon-data-analysis",
            style:
              Number(getLocalProject()) === 36
                ? "display:block"
                : "display:none",
          },
          {
            title: "UI测试",
            path: "/ui_test_smg_report",
            icon: "el-icon-data-analysis",
            style:
              Number(getLocalProject()) === 59
                ? "display:block"
                : "display:none",
            children: [
              {
                title: "UI测试报告",
                path: "/ui_test_smg_report",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 59,
              },
            ],
          },
          {
            title: "UI&关卡测试",
            path: "/ui_and_level_test_report",
            icon: "el-icon-data-analysis",
            style:
              Number(getLocalProject()) === 59
                ? "display:block"
                : "display:none",
            children: [
              {
                title: "UI&关卡测试报告",
                path: "/ui_and_level_test_report",
                icon: "el-icon-data-analysis",
                show: Number(getLocalProject()) === 59,
              },
            ],
          },
          {
            title: "MonoDump",
            path: "/mono_dump",
            icon: "el-icon-c-scale-to-original",
            style:
              Number(getLocalProject()) === 13 ||
              Number(getLocalProject()) === 15 ||
              Number(getLocalProject()) === 16 ||
              Number(getLocalProject()) === 44
                ? "display:block"
                : "display:none",
          },
          {
            title: "xHook",
            path: "/x_hook",
            icon: "el-icon-tickets",
            style:
              Number(getLocalProject()) === 13 ||
              Number(getLocalProject()) === 15 ||
              Number(getLocalProject()) === 16
                ? "display:block"
                : "display:none",
          },
          {
            title: "标签场景报告",
            path: "/label_scenario_report",
            icon: "el-icon-tickets",
            style:
              Number(getLocalProject()) === 8 ||
              Number(getLocalProject()) === 59 ||
              Number(getLocalProject()) === 54 ||
              Number(getLocalProject()) === 49
                ? "display:block"
                : "display:none",
          },

          {
            title: "标签场景热力图",
            path: "/label_scenario_diagram",
            icon: "el-icon-tickets",
            style:
              Number(getLocalProject()) === 8 ||
              Number(getLocalProject()) === 20
                ? "display:block"
                : "display:none",
          },
          // {
          //   title: "wedo",
          //   path: "/wedo",
          //   icon: "el-icon-tickets",
          //   style:
          //     Number(getLocalProject()) === 27
          //       ? "display:block"
          //       : "display:none",
          // },
          {
            title: "自定义报告",
            path: "/custom_report",
            icon: "el-icon-tickets",
            // style: ''
            style:
              Number(getLocalProject()) === 18 ||
              Number(getLocalProject()) === 14 ||
              Number(getLocalProject()) === 23 ||
              Number(getLocalProject()) === 24
                ? "display:block"
                : "display:none",
          },
          // {
          //   title: "测试",
          //   path: "/reactars",
          //   icon: "el-icon-menu",
          // },
        ],
      },
    ];
    // (this.get_is_super as any)=true
    // console.log(this.get_is_super)
    return this.get_is_super
      ? this.filterMenu(asideMenuVal2, this.pagesList)
      : this.filterMenu(asideMenuVal, this.pagesList);
  }
  public changeProject(value: any) {
    dispatchUpdateMyLastProject(store, { last_visit_project: value });
    saveLocalProject(String(value));
    saveLocalStorageProject(String(value));
    // 不可注释
    this.$router.push({
      path: "/test",
    });
  }
  public default_openeds_array: any = [];
  public handleOpen(key: string, keyPath: string) {
    this.default_openeds_array.push(key, keyPath);
  }
  getProjects(search?: string) {
    const projects: any[] = readMyProjects(store);

    for (let project of projects) {
      project.label = project.project.project_name;
      project.value = project.project.id;
    }

    return unique_json(projects, "value").filter(
      (data) =>
        !search || data.label?.toLowerCase().includes(search.toLowerCase())
    );
  }
  get getMyLastProjectName() {
    for (let project of readAdminProjects(store)) {
      if (project.id === this.localProject) {
        return project.project_name;
      }
    }
    return this.getProjects().filter(
      (item) => item.id === this.localProject
    )[0];
  }
  public filterMenu(menuList, filterArr) {
    if (filterArr.length === 0) return menuList;
    else {
      menuList = menuList.reduce((result, item) => {
        if (filterArr.includes(item.title)) {
          result.push(item);
        } else if (item.sub) {
          const filteredSub = this.filterMenu(item.sub, filterArr);
          if (filteredSub.length > 0) {
            result.push({ ...item, sub: filteredSub });
          }
        }
        return result;
      }, []);

      console.log('menuList', menuList)
      return menuList
    }
  }
  // 侧边栏固定
  public fixed = false;
  public fixedActiveBtn() {
    var scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;

    scrollTop >= 62 ? (this.fixed = true) : (this.fixed = false);

    if (this.fixed == true) {
      document
        .getElementsByClassName("el-menu")[0]
        .setAttribute(
          "style",
          "position:fixed;width: 220px;top:0px;background-color:#545c64;border: 0; overflow-x: hidden;"
        );
    } else {
      document
        .getElementsByClassName("el-menu")[0]
        .setAttribute(
          "style",
          `position:fixed;width: 220px;top:${
            62 - scrollTop
          }background-color:#545c64;border: 0;`
        );
    }
  }
  public get use_name_super() {
    let name = ["pagezhang", "v_baofeiyan", "v_yihuideng", "derosamei"];

    return name.includes(readUserProfile(store)?.username);
  }
  public get use_name_super1() {
    let name = ["pagezhang", "v_baofeiyan", "v_yihuideng"];

    return name.includes(readUserProfile(store)?.username);
  }
  public get use_name_super2() {
    let name = [
      "pagezhang",
      "v_baofeiyan",
      "v_yihuideng",
      "pikachuren",
      "febechen",
    ];

    return name.includes(readUserProfile(store)?.username);
  }
  // 判断是否是管理员
  public get get_is_super() {
    let judge = true;
    let MyProject = readMyProjects(store).filter(
      (item: any) => item.project.id == this.localProject
    )[0]?.is_project_admin;
    if (readUserProfile(store)?.is_super) {
      judge = false;
    } else if (MyProject) {
      judge = false;
    } else {
      judge = true;
    }
    return judge;
  }
  // 得到当前项目的图标
  public get currentProjectIcon() {
    return readProjectDetail(store).icon;
  }
}
